import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export const SaveHorseWeight = ({ kg, source, defaultName = "", id }) => {
  const { user } = useAuth();
  const [horses, setHorses] = useState([]);
  const [name, setName] = useState(defaultName);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (user) api.get("/horses").then((r) => setHorses(r.data)); }, [user]);
  useEffect(() => { if (defaultName) setName(defaultName); }, [defaultName]);
  if (!user) return <p className="text-sm text-slate-600 mt-4" data-testid={`${id}-login`}><Link to="/login?next=/peso" className="text-[#DC2626] font-bold">Inicia sesión</Link> para guardar este peso en el historial de tu caballo.</p>;
  const save = async () => {
    setBusy(true);
    try {
      await api.post("/horses/weights", { name, kg, source });
      toast.success(`Peso guardado en el historial de ${name}`);
      api.get("/horses").then((r) => setHorses(r.data));
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="mt-4 flex flex-wrap items-center gap-2" data-testid={id}>
      <input list={`${id}-horses`} value={name} onChange={(e) => setName(e.target.value)} placeholder="Nombre del caballo" maxLength={60}
        className="flex-1 min-w-[10rem] h-11 rounded-full border border-slate-300 px-4 text-sm focus:border-[#2563EB] outline-none" data-testid={`${id}-name`} />
      <datalist id={`${id}-horses`}>{horses.map((h) => <option key={h.id} value={h.name} />)}</datalist>
      <button type="button" disabled={busy || !name.trim() || !kg} onClick={save} data-testid={`${id}-button`}
        className="h-11 inline-flex items-center gap-2 border-2 border-[#0B1D3A] text-[#0B1D3A] hover:bg-[#0B1D3A] hover:text-white disabled:opacity-40 font-display font-bold px-5 rounded-full transition-colors">
        <Save size={16} /> Guardar en mi cuenta
      </button>
    </div>
  );
};
